import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import CabinsFullWidth from "../components/cabinsFullWidth"
import GalleryBlock from "../elements/galleryBlock"

const Gallery = () => {  

  return (
    <Layout>
      <SEO
        title="Gallery"
        description="Photo gallery of Gold Coast Retreat's Tofino vacation cabins and the surrounding Chesterman Beach rainforest setting."
      />
      <GalleryBlock />
      <CabinsFullWidth />
    </Layout>
  )
}

export default Gallery